import React from 'react';
import { Link } from 'react-router-dom';
import EditButton from '../../ui/EditButton';
import { isClubLaunchChecklistComplete } from '../utils/clubLaunch';
export default function AvailabilityCard({
  teamId,
  availability,
  onEdit,
  checklist = {},
  onLaunch
}) {
  const {
    live,
    public: isPublic,
    joinable
  } = availability;
  const readableJoinable = {
    Open: 'Open to anyone',
    Closed: 'Closed to new members',
    'On Approval': 'Join requests only'
  };
  const joinPath = `/join/${teamId}`;
  const fullJoinUrl = `${window.location.origin}${joinPath}`;
  const handleCopy = () => {
    navigator.clipboard.writeText(fullJoinUrl).then(() => {
      alert('Link copied to clipboard!');
    });
  };
  const allChecklistComplete = isClubLaunchChecklistComplete(checklist);
  return <div className="team-card">
      <div className="card-header-with-icon">
        <span className="card-title">{live ? 'Access Controls' : 'Go Live'}</span>
        {live && <EditButton section="availability" onEdit={onEdit} />}
      </div>

      <div className="card-body">
        {!live && <div className={`club-launch-card-callout${allChecklistComplete ? ' ready' : ''}`}>
          <span className="club-launch-card-callout__icon" aria-hidden="true">{allChecklistComplete ? '🚀' : '✓'}</span>
          <div>
            <strong>{allChecklistComplete ? 'Your club is ready to launch' : 'Finish setting up your club'}</strong>
            <p>{allChecklistComplete
              ? 'Review joining access and make your club live.'
              : 'We’ll guide you through each remaining step.'}</p>
          </div>
          <button type="button" className="button button-primary club-launch-card-callout__action" onClick={onLaunch}>
            {allChecklistComplete ? 'Go Live' : 'Finish setup'}
          </button>
        </div>}

        <ul className="availability-status-list">
          <li className="availability-status-item">
            <div className="availability-status-label">
              <span className="availability-status-icon">{live ? '✅' : '❌'}</span>
              <span>Live</span>
            </div>
            <span className={`availability-pill ${live ? 'available' : 'unavailable'}`}>
              {live ? 'Yes' : 'No'}
            </span>
          </li>

          <li className="availability-status-item">
            <div className="availability-status-label">
              <span className="availability-status-icon">{isPublic ? '✅' : '❌'}</span>
              <span>Public</span>
            </div>
            <span className={`availability-pill ${isPublic ? 'available' : 'unavailable'}`}>
              {isPublic ? 'Yes' : 'No'}
            </span>
          </li>

          <li className="availability-status-item">
            <div className="availability-status-label">
              <span className="availability-status-icon">📬</span>
              <span>Joinable</span>
            </div>
            <span className="availability-pill available">
              {readableJoinable[joinable] || 'Unknown'}
            </span>
          </li>
        </ul>

        {(joinable === 'Open' || joinable === 'On Approval') && <div className="join-link-container" style={{
        marginTop: '1rem'
      }}>
            <p className="join-link-label" style={{
          fontWeight: 500
        }}>Joining link:</p>
            <div style={{
          display: 'flex',
          gap: '0.5rem',
          alignItems: 'center',
          flexWrap: 'wrap',
          wordBreak: 'break-all'
        }}>
              <code style={{
            background: '#f5f5f5',
            padding: '0.25rem 0.5rem',
            borderRadius: '4px',
            fontSize: '0.875rem',
            flexGrow: 1,
            overflowWrap: 'anywhere',
            maxWidth: '100%'
          }}>
                <Link to={joinPath} className="join-link" style={{
              color: '#0066cc'
            }}>
                  {fullJoinUrl}
                </Link>
              </code>
              <button type="button" onClick={handleCopy} className="copy-button" style={{
            background: 'none',
            border: '1px solid #ccc',
            padding: '0.25rem 0.5rem',
            borderRadius: '4px',
            cursor: 'pointer',
            whiteSpace: 'nowrap'
          }}>
                Copy
              </button>
            </div>
          </div>}
      </div>
    </div>;
}
